<div style="padding: 1rem">
    <h5 style="margin-bottom: 1rem">{{ savedViewToEdit ? lang.GetValue('SavedViews.UpdateView') : lang.GetValue('SavedViews.CreateView') }}</h5>
    <trv-form [validationErrors]="validationErrorMap">
        <trv-form-field label="{{ lang.GetValue('SavedViews.Name') }}" [labelGridColumns]="3" [control]="name">
            <input type="text" class="form-control" placeholder="{{ lang.GetValue('SavedViews.ViewName') }}" [formControl]="name" />
        </trv-form-field>
        <trv-form-field label="{{ lang.GetValue('SavedViews.Layer') }}" [labelGridColumns]="3" [control]="saveBackground" [controlPadding]="true">
            <div class="form-check custom-checkbox">
                <input type="checkbox" id="simpleCheck1" class="form-check-input" [formControl]="saveBackground" [value]="1" checked="true" />
                <label style="width: 15rem" class="form-check-label" for="simpleCheck1">{{ lang.GetValue('SavedViews.SaveCurrentBackground') }}</label>
            </div>
            <div class="form-check custom-checkbox">
                <input type="checkbox" id="simpleCheck2" class="form-check-input" [formControl]="saveDatalayer" [value]="1" checked="true" />
                <label style="width: 15rem" class="form-check-label" for="simpleCheck2">{{ lang.GetValue('SavedViews.SaveCurrentLayer') }}</label>
            </div>
        </trv-form-field>
    </trv-form>
    <button class="btn btn-primary save_button" (click)="submit()">{{ lang.GetValue('SavedViews.SaveView') }}</button>
</div>
